import { RoleDto } from "@merchant_api/models/role-dto";
import { UserDetailsDto } from "@merchant_api/models/user-details-dto";

export class UserState {
    loading = false;
    error = null;
    user: UserDetailsDto = null;
    roleList: RoleDto[] = null;
}
